// The `ms` namespace the closure/ modules attach to (was goog.provide('ms.*')).
const ms = {};

export default ms;
